export default {
    "Year": "2020",
    "Company Name": "苏州矩步引领软件科技有限公司姑苏分公司\n",
    "Product Name": "成语接龙",
    "ICP": "苏ICP备20031298号-2",
    "Pic": [
        require("./480x800/1-480.jpg"),
        require("./480x800/2-480.jpg"),
        require("./480x800/3-480.jpg")
    ],
    "Mail address": "苏州市姑苏区泰南路15号1号楼122室",
    "Phone": "0512-65685970",
    "Html With Markdown": {
        // 示列：require("./AboutDeal.md") 用来替换默认模板内容
        // 如果md里面没有内容效果等同于false
        AboutDeal: false,
        UserPrivacy: false
    }
}